import { type OrderItem } from '../../types';

export const getOrderTypeByItems = (orderItems?: OrderItem[]) => orderItems?.map((o) => o.category).join();
